<template>
    <div style="width: 800px; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;">
        <div style="font-size: 20px;text-align: center; font-weight: bold; margin-bottom: 20px;">Направление отдыха турагентства «Мечта»</div>
        <ol style="margin-left: 20px; font-size: 14px;">
            <li>
                <strong>Июль в Израиле</strong>
                <p>Израиль — страна, которая всегда удивляет туристов и оставляет незабываемые впечатления от путешествия. Просто невероятно: на такой маленькой территории есть все, о чем только могут мечтать неискушенные и бывалые путешественники: красоты первозданной природы, солнечные пляжи, богатое наследие древних времен и современные достопримечательности, поражающие воображение.</p>
                <p>Предложение: Прекрасный отель Grand-Plaza (все включено), оформление визы за неделю; включены три экскурсии.</p>
            </li>

            <li>
                <strong>Незабываемая Италия</strong>
                <p>
                    Прекрасный климат Италии сделает заставит вас полюбить эту страну. Мы предлагаем вам размещение в одном из лучших отелей и посещение красивых мест католической Италии.
                    <br/>Описание: тур предлагается лицам старше 21 года, обязательное страхование, гарантия на возврат денег в случае отклонения визы.
                </p>
            </li>

            <li>
                <strong>Отдых в Индии</strong>
                <p>
                    Познакомьтесь с удивительной культурой Индии, попутешествуйте на слонах и попробуйте блюда традиционной кухни. Специальное предложение. Спешите!
                    <br/>Требования: обязательно страхование жизни, прививка от малярии, вылет с животными запрещен.
                </p>
            </li>

            <li>
                <strong>Канада</strong>
                <p>
                    Страна, где говорят на двух языках, совместившая в себе лучшее от двух культур. Спешите воспользоваться экспресс предложением от нашей компании. Оформление визы за пять дней, или мы вернем вам деньги!
                </p>
            </li>

            <li>
                <strong>Япония</strong>
                <p>
                    Одна из самых быстроразвивающихся экономик мира; прекрасные города, плотно заселенные людьми, которые, кажется, никогда не спят.
                    <br/>Условия: для граждан РФ необходимо оформление визы.
                </p>
            </li>
        </ol>
    </div>
</template>
<script>
    export default {}
</script>
<style scoped>
    .id58-p {
        padding: 4px;
    }
</style>
